module.exports = __webpack_public_path__ + "static/bg-movie-d4ab9ef92c6e56b8955afbf95fa70b82.jpg";